import * as _ from "lodash";
import classNames from "classnames";
import squish from 'object-squish';
// React
import React from "react";
// Griddle
import Griddle from "griddle-react";
import * as RenderAs from "common/ui/components/table/renderAs";
import ReportFooter from "common/ui/components/table/ReportFooter";
import { SearchFilter } from "common/ui/components/table/SearchFilter";
import { FilterDropdown } from "common/ui/components/inputs/FilterDropdown";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./FullTable.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class FullTable extends React.Component {
    constructor(props) {
        super(props);
        this._fastSearchStrings = [];
        if (window.innerHeight && window.innerHeight < 700) {
            this.state = { resultsPerPageOption: "10" };
        }
        else {
            this.state = { resultsPerPageOption: "20" };
        }
        this.customFilterFunction = this.customFilterFunction.bind(this);
    }
    componentDidMount() {
        // Clear global filters
        globalFilterHack = [];
        const nextProps = this.props;
        if (this._fastSearchStrings.length === 0) { // || this.props.reportKey !== nextProps.reportKey) {
            const { excludeColumnsFromFilter, reportItems } = nextProps;
            const columnsFilter = excludeColumnsFromFilter || [];
            for (let row in reportItems) {
                var flatRow = squish(reportItems[row], { includeArrays: true });
                let rowStrings = [];
                for (let key in flatRow) {
                    if (flatRow[key] && !_.includes(columnsFilter, key)) {
                        const flatField = flatRow[key].toString();
                        const flatRowWordsLower = flatField.toLowerCase();
                        const flatRowWords = flatRowWordsLower.split(" ");
                        rowStrings = [...rowStrings, ...flatRowWords];
                    }
                }
                ;
                this._fastSearchStrings.push(rowStrings);
            }
            ;
        }
    }
    renderResultsPerPage() {
        //-- filters
        const filterOptions = [
            { keyName: "10", displayName: "10", id: 10 },
            { keyName: "15", displayName: "15", id: 15 },
            { keyName: "20", displayName: "20", id: 20 },
            { keyName: "50", displayName: "50", id: 50 }
        ];
        return React.createElement("div", { className: classNames("griddle-resultsPerPage", styles.resultsPerPage) },
            React.createElement("span", { className: styles.filterTitle }, "Results per page"),
            React.createElement(FilterDropdown, { keyName: "Listing Type", clickCallback: (selection) => this.setState({ resultsPerPageOption: selection }), filters: filterOptions, selection: this.state.resultsPerPageOption }));
    }
    customFilterFunction(items, query) {
        const searchQuery = query.toLowerCase();
        const splitSearchQuery = searchQuery.split(" ");
        let splitQuery = splitSearchQuery;
        for (let key in globalFilterHack) {
            if (globalFilterHack[key] != "") {
                let globalFilterSplit = globalFilterHack[key].split(" ");
                splitQuery = [...splitQuery, ...globalFilterSplit];
            }
        }
        splitQuery = splitQuery.filter((value) => value && value != "");
        if (splitQuery.length == 0) {
            return items;
        }
        return _.filter(items, (item, index) => {
            //var flat = squish(item);
            for (const queryPart of splitQuery) {
                let isInAny = false;
                for (const rowString of this._fastSearchStrings[index]) {
                    if (rowString.startsWith(queryPart)) {
                        isInAny = true;
                    }
                }
                if (!isInAny) {
                    return false;
                }
            }
            return true;
        });
    }
    render() {
        const { reportItems, metaData, initialSort } = this.props;
        return (React.createElement("div", { className: styles.container },
            this.renderResultsPerPage(),
            React.createElement(Griddle, { results: reportItems, tableClassName: "griddle-report", columnMetadata: metaData, filterPlaceholderText: "Search...", showSettings: false, resultsPerPage: parseInt(this.state.resultsPerPageOption), sortAscendingComponent: React.createElement("span", { className: "fa fa-sort-asc" }), sortDescendingComponent: React.createElement("span", { className: "fa fa-sort-desc" }), initialSort: initialSort, useGriddleStyles: true, customNoDataComponent: RenderAs.renderAsNoData, settingsToggleClassName: "griddleSettings btn btn-sm btn-primary", settingsIconComponent: React.createElement("span", { className: "fa fa-cog" }), showFilter: true, useCustomFilterer: true, customFilterer: this.customFilterFunction, metadataColumns: this.props.excludeColumns, useCustomFilterComponent: true, customFilterComponent: SearchFilter, useFixedHeader: false, showPager: true, useCustomPagerComponent: true, customPagerComponent: ReportFooter })));
    }
}
